import FileDropzoneContainer from './FileDropzoneContainer.jsx';

export default FileDropzoneContainer;
